<template>
    <div class="container-fluid">
        <div class="row no-gutter">
            <div class="col-lg-3 bg-image"></div>
            <div class="col-lg-9">
                <div class="login d-flex align-items-center">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6 col-md-8 mx-auto">
                                <div class="mb-8 text-center">
                                    <img class="img-fluid" src="/client/images/logo-login.png" />
                                </div>

                                <div class="form-group mb-2">
                                    <input
                                        class="form-control rounded"
                                        :class="{ 'is-invalid': formErrors.password && formErrors.password.length }"
                                        type="password"
                                        placeholder="New password"
                                        v-model="form.password"
                                    />

                                    <small
                                        class="text-danger font-italic"
                                        style="font-size: 12px"
                                        v-if="formErrors.password && formErrors.password.length"
                                    >
                                        {{ formErrors.password[0] }}
                                    </small>
                                </div>

                                <div class="form-group mb-3">
                                    <input
                                        class="form-control rounded"
                                        :class="{
                                            'is-invalid':
                                                formErrors.confirmPassword && formErrors.confirmPassword.length
                                        }"
                                        type="password"
                                        placeholder="Confirm password"
                                        v-model="form.confirmPassword"
                                    />

                                    <small
                                        class="text-danger font-italic"
                                        style="font-size: 12px"
                                        v-if="formErrors.confirmPassword && formErrors.confirmPassword.length"
                                    >
                                        {{ formErrors.confirmPassword[0] }}
                                    </small>
                                </div>

                                <button class="btn btn-secondary mb-4 w-100" type="button" v-on:click="reset">
                                    Reset password
                                </button>
                            </div>
                            <div class="footer-address">
                                <small class="text-muted mx-auto">
                                    18 St George's Place, Cheltenham, Gloucestershire. GL50 3JZ
                                    <br />
                                    T: 01242 571883 | E: office@owltherapycentre.co.uk
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    import authService from '@api/auth';

    export default Vue.extend({
        data() {
            return {
                form: {
                    confirmPassword: '',
                    password: '',
                    token: this.$route.query.token
                },
                formErrors: {}
            };
        },
        methods: {
            reset() {
                authService
                    .reset(this.form)
                    .then(() => {
                        this.$toasted.success('The password has been successfully reset.');
                        this.$router.push('/login');
                    })
                    .catch((error) => {
                        if (error.response.data.errors) {
                            this.formErrors = error.response.data.errors;
                            this.$toasted.error(
                                'Please enter a valid value in all the required fields before proceeding.',
                                { icon: 'exclamation-triangle' }
                            );
                            this.$goToError();
                        } else {
                            window.location.href = `/error/${error.response.status}`;
                        }
                    });
            }
        },
        created() {
            if (!this.form.token) {
                this.$toasted.error('The token provided is invalid.', {
                    icon: 'exclamation-triangle'
                });

                this.$router.push('/login');
            }

            window.document.title = `Reset password | ${window.app.title}`;
        }
    });
</script>
